export default __webpack_public_path__ + "static/media/H T Parekh Foundation Logo_Final_ 22-11-2017_for Corporate Branding.08d08171.png";